import "core-js/modules/web.dom-collections.iterator.js";
import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'react-final-form';
import { StandardButton } from '@eika/button';
import { AnswerType, QuestionType, ValueType } from '../generated-types';
import { CheckboxListField } from '../types/checkbox-list-field';
import SelectInput from '../types/select-input';
import { StandardInputField } from '../types/standard-input-field';
import YesNoQuestionType from '../types/yes-no-question-type';
import { createStructureForSubmit } from '../util/dynamic-section-object';
import { getNameForFirstLevelQuestion } from '../util/field-name';
import HelpModal from '../util/helpModals/help-modal';
import { composeValidators, focusOnErrors, requiredField, valueNotAllowed } from '../util/validator';
import ErrorMessage from './error-message';
import OverlayLoader from './overlay-loader';
export const getDropDownValues = (question, countries) => {
  const dropDownValues = [{
    text: 'Velg',
    value: 'velg',
    key: '0'
  }];
  if (question.possibleValues) {
    question.possibleValues.forEach(value => {
      var _value$value;
      dropDownValues.push({
        text: value.text,
        value: (_value$value = value.value) !== null && _value$value !== void 0 ? _value$value : value.text
      });
    });
  }
  if (question.valueType === ValueType.COUNTRY) {
    if (countries !== null && countries !== void 0 && countries.countries) {
      countries.countries.filter(country => !country.historicUseOnly).forEach((country, i) => {
        dropDownValues.push({
          text: country.text,
          value: country.iso2,
          key: (i + 1).toString()
        });
      });
    }
  }
  return dropDownValues;
};
const DynamicSection = _ref => {
  let {
    dynamicSection,
    submitButtonText,
    countries,
    sectionIndex,
    onSubmit,
    submitDynamicSection,
    clearDynamicSection,
    submittedSection
  } = _ref;
  const [loading, setLoading] = useState(false);
  const formRef = useRef();
  useEffect(() => {
    if (submittedSection.submitted && submittedSection.sectionIndex === sectionIndex) {
      var _formRef$current;
      setLoading(false);
      clearDynamicSection(sectionIndex);
      onSubmit();
      (_formRef$current = formRef.current) === null || _formRef$current === void 0 || _formRef$current.restart();
    }
  }, [submittedSection, onSubmit, sectionIndex, clearDynamicSection]);
  const renderQuestion = (question, values, index, setValueOfField) => {
    switch (question.type) {
      case QuestionType.CHOICE_YES_NO:
        return /*#__PURE__*/React.createElement(YesNoQuestionType, {
          name: getNameForFirstLevelQuestion(index),
          question: question,
          countries: countries,
          setValueOfField: setValueOfField,
          setInitialValueOfSpecialFields: !(submittedSection !== null && submittedSection !== void 0 && submittedSection.error) && !(submittedSection !== null && submittedSection !== void 0 && submittedSection.submitted),
          renderLabelAsHtml: true
        });
      case QuestionType.DROP_DOWN:
        return /*#__PURE__*/React.createElement(SelectInput, {
          label: question.text,
          name: getNameForFirstLevelQuestion(index),
          values: getDropDownValues(question, countries),
          validate: composeValidators(requiredField, value => valueNotAllowed(value, 'velg', 'Velg')),
          onChangeOverride: event => {
            return {
              questionId: question.id,
              questionVersion: question.version,
              answer: event.target.value,
              answerType: AnswerType.SINGLE
            };
          },
          overrideValueKey: "answer"
        });
      case QuestionType.AMOUNT:
        return /*#__PURE__*/React.createElement(StandardInputField, {
          name: getNameForFirstLevelQuestion(index),
          label: question.text,
          key: question.id,
          type: "number",
          validate: requiredField,
          infoButton: /*#__PURE__*/React.createElement(HelpModal, {
            helpText: question.helpText,
            questionId: question.id
          }),
          onChangeOverride: event => {
            return {
              questionId: question.id,
              questionVersion: question.version,
              answer: event.target.value,
              answerType: AnswerType.SINGLE
            };
          },
          overrideValueKey: "answer"
        });
      case QuestionType.CHECKBOX_LIST:
        return /*#__PURE__*/React.createElement(CheckboxListField, {
          name: getNameForFirstLevelQuestion(index),
          key: question.id,
          question: question,
          selectedValues: (values === null || values === void 0 ? void 0 : values.answers) && values.answers[index]
        });
      default:
        return "".concat(question.text, " - ").concat(question.type, " (UNSUPPORTED)");
    }
  };
  const submitValues = values => {
    setLoading(true);
    const answers = createStructureForSubmit(values.answers);
    submitDynamicSection(answers, sectionIndex);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, loading && !submittedSection.error ? /*#__PURE__*/React.createElement(OverlayLoader, null) : undefined, /*#__PURE__*/React.createElement("h2", {
    className: "header-title"
  }, dynamicSection.sectionText), /*#__PURE__*/React.createElement(Form, {
    onSubmit: submitValues,
    decorators: [focusOnErrors],
    formName: "".concat(dynamicSection.sectionCode, "_").concat(dynamicSection.sectionText),
    mutators: {
      setValueOfField: (args, state, utils) => {
        utils.changeValue(state, args[0].key, () => args[0].value);
      }
    },
    destroyOnUnregister: true
  }, props => {
    formRef.current = props.form;
    return /*#__PURE__*/React.createElement("form", {
      onSubmit: event => {
        event.preventDefault();
        props.handleSubmit(event);
      }
    }, dynamicSection.questions.map((question, index) => {
      return /*#__PURE__*/React.createElement("div", {
        key: question.id,
        className: "form-question"
      }, renderQuestion(question, props.values, index, props.form.mutators.setValueOfField));
    }), submittedSection.error && /*#__PURE__*/React.createElement("div", {
      className: "form-question"
    }, /*#__PURE__*/React.createElement(ErrorMessage, {
      text: "Noe gikk galt n\xE5r vi pr\xF8vde \xE5 lagre svarene, vennligst pr\xF8v igjen. Dersom problemet vedvarer m\xE5 du kontakte banken"
    })), /*#__PURE__*/React.createElement(StandardButton, {
      className: "progress-next-button",
      type: "submit"
    }, submitButtonText));
  }));
};
export default DynamicSection;